import { APIMethod, fetchData } from "@client";

export async function removeProjectVersionComment(
  commentUuid,
  projectUuid,
  userUuid,
  versionKey,
) {
  await fetchData(
    `v1/ws/project/comments/${commentUuid}`,
    APIMethod.DELETE,
    {
      data: {
        uuid: projectUuid,
        user: userUuid,
        version: versionKey,
      }
    }
  );
}